interface AvoidedConservationEmissionsProps {
  co2EmissionsAvoidedNoDeductions: string
  leakageDeduction: string
  nonPermanenceDeduction: string
  spontaneousEmissions: string
  projectEmissions: string
}

export function AvoidedConservationEmissions({
  co2EmissionsAvoidedNoDeductions,
  leakageDeduction,
  nonPermanenceDeduction,
  spontaneousEmissions,
  projectEmissions,
}: AvoidedConservationEmissionsProps) {
  return (
    <div className="order-1 col-span-6 max-w-full lg:col-span-2 lg:w-116">
      <div className="flex flex-col gap-8 text-center md:text-start">
        <div className="space-y-4 rounded-2xl bg-linear-to-t from-bios-darkGreen-200 to-bios-darkGreen-100 px-8 py-4 shadow-2xl">
          <h1 className="max-w-80 text-3xl text-white">
            Total de emissões evitadas por meio da conservação
          </h1>

          <div className="flex flex-col justify-center gap-2 lg:items-start">
            <span className="w-full text-lg font-bold text-bios-primary 2xl:text-xl">
              CO₂ antes dos descontos
            </span>

            <span className="flex flex-col items-center justify-center gap-2 text-wrap text-white lg:flex-row">
              <p className="text-4xl 2xl:text-5xl">
                {co2EmissionsAvoidedNoDeductions}
              </p>
              <p>tCO₂e/ano</p>
            </span>
          </div>
        </div>

        <div className="flex size-full flex-col rounded-2xl shadow-2xl *:px-8 *:py-4">
          <div className="flex flex-col gap-2 rounded-t-2xl bg-linear-to-t from-bios-lime-950 to-bios-200 text-white">
            <h1 className="max-w-80 text-3xl font-semibold text-bios-green-2000">
              Descontos
            </h1>

            <div className="flex flex-col items-center justify-between gap-8 text-bios-darkGreen-300 lg:flex-row lg:gap-16">
              <span className="w-full text-lg font-bold 2xl:text-xl">
                Por vazamentos (15%)
              </span>

              <span className="text-wrap">
                <p className="text-4xl font-bold 2xl:text-5xl">
                  {leakageDeduction}
                </p>
                <p>tCO₂e/ano</p>
              </span>
            </div>
          </div>

          <div className="flex min-h-32 flex-col items-center justify-between gap-8 bg-bios-yellow-200 py-12 lg:flex-row lg:gap-16">
            <span className="max-w-full text-balance text-lg font-bold text-bios-darkGreen-300 2xl:text-xl">
              De não permanência (10%)
            </span>

            <span>
              <p className="text-4xl font-bold text-bios-primary 2xl:text-5xl">
                {nonPermanenceDeduction}
              </p>
              <p className="text-bios-darkGreen-300">tCO₂e/ano</p>
            </span>
          </div>

          <div className="flex min-h-32 flex-col items-center justify-between gap-8 bg-linear-to-b from-bios-darkGreen-50 to-bios-green-400 lg:flex-row lg:gap-10">
            <span className="max-w-full text-lg font-bold text-bios-darkGreen-300 2xl:text-xl">
              De emissões espontâneas do projeto em conservação
            </span>

            <span>
              <p className="text-4xl font-bold text-white 2xl:text-5xl">
                {spontaneousEmissions}
              </p>
              <p className="text-bios-darkGreen-300">tCO₂e/ano</p>
            </span>
          </div>

          <div className="flex min-h-32 flex-col items-center justify-between gap-8 rounded-b-2xl bg-white bg-linear-to-b lg:flex-row lg:gap-16">
            <span className="max-w-full text-lg font-bold text-bios-darkGreen-300 2xl:text-xl">
              Emissões internas (Infraestrutura e manejo)
            </span>

            <span>
              <p className="text-4xl font-bold text-bios-primary 2xl:text-5xl">
                {projectEmissions}
              </p>
              <p className="text-bios-darkGreen-300">tCO₂e/ano</p>
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
